"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Text = _interopRequireDefault(require("../Text"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Script = (0, _styledComponents.default)(_Text.default)(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  text-transform: none;\n  display: inline-block;\n  transform: ", ";\n"], ["\n  text-transform: none;\n  display: inline-block;\n  transform: ", ";\n"])), function (_a) {
  var tilt = _a.tilt;
  return "rotate(-" + tilt + "deg)";
});
Script.defaultProps = {
  tilt: 0,
  fontFamily: 'lcScript'
};
var _default = Script;
exports.default = _default;
var templateObject_1;